/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { adDesignUpdateDefaults } from '../../axios/adDesignUpdateDefaults'
import type {
	AdDesignUpdateDefaultsError,
	AdDesignUpdateDefaultsPathParams,
	AdDesignUpdateDefaultsRequest,
	AdDesignUpdateDefaultsResponse,
} from '../../types/AdDesignUpdateDefaults'

export const adDesignUpdateDefaultsMutationKey = () =>
	[{ url: '/organisations/:organisation/default-designs' }] as const

export type AdDesignUpdateDefaultsMutationKey = ReturnType<typeof adDesignUpdateDefaultsMutationKey>

export type AdDesignUpdateDefaultsVariables = {
	organisation: AdDesignUpdateDefaultsPathParams['organisation']
	data: AdDesignUpdateDefaultsRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::updateDefaults */
export function useAdDesignUpdateDefaults<TContext = unknown>(
	options?: UseMutationOptions<
		AdDesignUpdateDefaultsResponse,
		AxiosError<AdDesignUpdateDefaultsError>,
		AdDesignUpdateDefaultsVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: adDesignUpdateDefaultsMutationKey(),
		mutationFn: ({ organisation, data }: AdDesignUpdateDefaultsVariables) =>
			adDesignUpdateDefaults(organisation, data, config).then(res => res.data),
		...options,
	})
}
